import {atom, selector} from "recoil";
import addressData from "utils/_data.json";
import {transformAddressData} from "utils/transform";


export const loadingPageState = atom({
   key: "loadingPageState",
   default: false,
});

export const cartState = atom({
   key: "cart",
   default: [],
});

export const orderState = atom({
   key: "orderState",
   default: {},
});
export const vatType= atom({
   key: 'orderVatType',
   default: {
      vat_type: 0
   }
});
export const showModalErrorOrderState = atom({
   key: "showModalErrorOrder",
   default: false,
});

export const cartCheckoutState = atom({
   key: "cartCheckout",
   default: {
      type: 0,
      data: [
         {value: 1, label: 'PROCESSING'},
         {value: 2, label: 'SHIPPING'},
         {value: 3, label: 'COMPLETED'},
         {value: 4, label: 'NOT_COMPLETED'},
         {value: 5, label: 'CANCELLED'},
      ],
   },
});

const provinceData = addressData.map(transformAddressData);
export const deliveryInfoState = atom({
   key: "deliveryInfo",
   default: {
      phoneNumber: {value: null, validate: null},
      receiverName: {value: null, validate: null},
      address: {value: null, validate: null},
      province: {list: provinceData, listOrigin: provinceData, value: null, validate: null}, // Tên tỉnh/thành phố
      ward: {list: [], listOrigin: [], value: null, validate: null}, // Tên xã/phường
      notes: ''
   },
});

export const totalAmountState = selector({
   key: "totalAmount",
   get: ({get}) => {
      const cart = get(cartState);
      const vat = get(vatType)
      const type= vat?.vat_type || 0
      return cart.reduce((total, item) => {
         const vatValue= +type === 2 && +item.order_vat_rate >= 0 ? +item.order_vat_rate : 0
         const vatPrice= (+vatValue * +item.quantity * +item.price) / 100
        return  total + (+item.quantity * +item.price + +vatPrice)
      }, 0);
   },
});

export const totalPriceState = selector({
   key: "totalPrice",
   get: ({get}) => {
      const cart = get(cartState);
      const vat = get(vatType)
      const type= vat?.vat_type || 0
      return cart.reduce((total, item) => {
         const vatValue= +type === 2 && +item.order_vat_rate >= 0 ? +item.order_vat_rate : 0
         const vatPrice= (+vatValue * +item.quantity * +item.price) / 100
         return total + (+item.quantity * +item.price + vatPrice)
      }, 0);
   },
});


export const totalQuantityState = selector({
   key: "totalQuantity",
   get: ({get}) => {
      const cart = get(cartState);
      return cart.reduce((total, item) => total + (+item.quantity), 0);
   },
});

export const attributeSheetState = atom({
   key: "attributeSheerState",
   default: {
      product: null,
      display: false
   }
});
export const attributesState = atom({
   key: "attributesState",
   default: []
});
export const attributesOriginState = atom({
   key: "attributesOriginStateT",
   default: []
});